module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-sidebar"
  }, [(!_vm.$root.isIos) ? _c('a', {
    staticClass: "pp-sidebar__brand",
    attrs: {
      "href": "https://pristineclassical.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/logo.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$root.isIos) ? _c('a', {
    staticClass: "pp-sidebar__brand",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/logo.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pp-sidebar__button",
    attrs: {
      "to": "/browse"
    }
  }, [_vm._v("\n        Browse\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-sidebar__button",
    attrs: {
      "to": "/browse/new"
    }
  }, [_vm._v("\n        New Releases\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-sidebar__button",
    attrs: {
      "to": "/browse/composers"
    }
  }, [_vm._v("\n        Composers\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-sidebar__button",
    attrs: {
      "to": "/browse/ensembles"
    }
  }, [_vm._v("\n        Ensembles\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-sidebar__button",
    attrs: {
      "to": "/browse/artists"
    }
  }, [_vm._v("\n        Artists\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-sidebar__button",
    attrs: {
      "to": "/browse/exclusive"
    }
  }, [_vm._v("\n        Exclusives\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-sidebar__button",
    attrs: {
      "to": "/queue"
    }
  }, [_vm._v("\n        Queue\n    ")]), _vm._v(" "), (_vm.account && _vm.account.id) ? _c('div', {
    staticClass: "pp-sidebar__footer"
  }, [_c('div', {
    staticClass: "pp-sidebar__account"
  }, [_c('div', {
    staticClass: "pp-sidebar__account__identity"
  }, [_vm._v("\n                Logged in as " + _vm._s(_vm.account.name) + ".\n                "), _c('router-link', {
    attrs: {
      "to": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-info-circle"
  })])], 1), _vm._v(" "), (_vm.account.plan) ? _c('div', {
    staticClass: "pp-sidebar__account__plan"
  }, [_vm._v("\n                Plan: " + _vm._s(_vm.account.plan) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.account.plan) ? _c('div', {
    staticClass: "pp-sidebar__account__plan"
  }, [(_vm.account.freePlays > 0) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.account.freePlays) + " free plays available\n                ")]) : _vm._e(), _vm._v(" "), (_vm.account.freePlays == 0) ? _c('span', [_vm._v("\n                    You've used all your free plays\n                ")]) : _vm._e(), _vm._v("\n                -\n                "), (!_vm.root.isIos) ? _c('a', {
    attrs: {
      "href": "https://www.pristineclassical.com/pages/player-subscribe"
    }
  }, [_vm._v("\n                    subscribe\n                ")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.account && !_vm.account.id) ? _c('div', {
    staticClass: "pp-sidebar__footer"
  }, [_c('div', {
    staticClass: "pp-sidebar__account"
  }, [_c('div', {
    staticClass: "pp-sidebar__account__identity"
  }, [_vm._v("\n                Browsing as guest -\n                "), (!_vm.$root.isIos) ? _c('a', {
    staticClass: "pp-sidebar__account__login",
    attrs: {
      "href": "https://www.pristineclassical.com/pages/player-subscribe"
    }
  }, [_vm._v("\n                    Log in or register\n                ")]) : _vm._e(), _vm._v(" "), (_vm.$root.isIos) ? _c('a', {
    staticClass: "pp-sidebar__account__login",
    attrs: {
      "href": "https://www.pristineclassical.com/pages/player-subscribe?signin_hidden=true"
    }
  }, [_vm._v("\n                    Log in\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pp-sidebar__account__plan"
  }, [(_vm.account.freePlays > 0) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.account.freePlays) + " free plays available\n                ")]) : _vm._e(), _vm._v(" "), (_vm.account.freePlays == 0) ? _c('span', [_vm._v("\n                    You've used all your free plays\n                ")]) : _vm._e()])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dd3852c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PpSidebar.vue
// module id = 175
// module chunks = 1